<template>
  <div class="d-inline">
    <v-btn color="primary" dark small @click.stop="dialog = true">
      Adicionar Potencial Degradador
    </v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline green darken-2 white--text lighten-2">
          Adicionar Potencial Degradador
        </v-card-title>

        <v-card-text>

          <v-form v-model="valid">
            <v-text-field
              v-model="degradingPotential.name"
              :rules="requiredRules"
              label="Descrição"
              required></v-text-field>
            <v-checkbox
                  v-model="degradingPotential.old"
                  label="Antigo?"
                  required
              />
          </v-form>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeDialog()">Cancelar</v-btn>
          <v-btn color="primary" flat @click="createDegradingPotentialForTax">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import DegradingPotentialForTaxService from '@/services/applications/configurations/DegradingPotentialForTaxService';
import validationRules from '@/mixins/validation-rules';

export default {
  name: 'CreateDegradingPotentialForTax',
  components: {},
  mixins: [validationRules],
  props: ['typologyId'],
  data() {
    return {
      requiredRules: [validationRules.required],
      dialog: false,
      valid: false,
      degradingPotential: {},
    };
  },
  methods: {
    createDegradingPotentialForTax() {
      const vm = this;

      DegradingPotentialForTaxService
        .createDegradingPotentialForTax(vm.typologyId, vm.degradingPotential)
        .then((response) => {
          vm.$swal({
            title: 'Potencial Degradador cadastrado com Sucesso',
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            vm.$emit('create-degrading-potential-for-tax', response.data);
            vm.closeDialog();
          });
        })
        .catch((error) => {
          vm.$swal({
            title: 'Erro',
            text: error.response.data.join('\n'),
            type: 'error',
            showConfirmButton: 'Ok',
          });
        });
    },
    closeDialog() {
      this.degradingPotential = {};
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
